import { render, staticRenderFns } from "./SettingsChangePhoto.vue?vue&type=template&id=42b2d51c&scoped=true&"
import script from "./SettingsChangePhoto.vue?vue&type=script&lang=js&"
export * from "./SettingsChangePhoto.vue?vue&type=script&lang=js&"
import style0 from "./SettingsChangePhoto.vue?vue&type=style&index=0&id=42b2d51c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b2d51c",
  null
  
)

export default component.exports